import type { AlpineComponent } from 'alpinejs'

// Wraps Alpine components in order to avoid having to write an explicit type for the entire component.
// Note that this requires params to be an object instead of an ordered list of values, which is arguably better anyway.
// Source: https://github.com/alpinejs/alpine/issues/2199#issuecomment-1809892127
export const defineComponent = <P, T>(fn: (params: P) => AlpineComponent<T>) => fn
